import * as React from "react";
import { AboutPageComp } from "../Components/AboutPageComp";

// markup
const AboutPage = (props) => {
  return <AboutPageComp props={props} />;
};

export default AboutPage;
